/**
 * 🎨 GRID PRESETS 2025
 * 
 * Vorgefertigte Grid-Strukturen mit Content
 * User kann diese als Basis verwenden und dann anpassen
 */

export const gridPresets = {
    // 🖼️ IMAGE WITH TEXT (2 Columns - Image Left, Text Right)
    'image-text-2col': {
        name: 'Image with Text',
        description: 'Round image with text content - professional card style',
        icon: 'fa-image',
        category: 'content',
        grid: {
            columns: 2,
            gap: 0,  // ✅ Kein Gap zwischen den Spalten
            gapMobile: 0,
            columnTemplate: '1-3',  // ✅ Tiny-Big (1:3 Verhältnis - Bild klein, Text groß)
            gridFlowMode: 'fixed',  // ✅ Fixed Flow Mode
            columnMinWidths: [230, null],  // ✅ Min Width für kleine Spalte (Bild) = 230px, große Spalte flexibel
            widthMode: 'limited',  // ✅ Limited Width Mode
            marginTop: 20,
            marginBottom: 20,
            marginLeft: 0,
            marginRight: 0,
            maxWidth: 900,  // ✅ Max Width 900px
            maxWidthMobile: 700,
            // ✅ Grid Container Padding
            paddingTop: 45,
            paddingBottom: 45,
            paddingLeft: 0,
            paddingRight: 0,
            paddingTopMobile: 45,
            paddingBottomMobile: 45,
            paddingLeftMobile: 0,
            paddingRightMobile: 0,
            gridDirection: 'horizontal',
            gridDirectionMobile: 'vertical',  // ✅ Mobile: Bild oben, Text unten
            // ✅ Grid Border & Shadow
            borderEnabled: true,
            borderWidth: 1,
            borderColor: '#d0d0d0',  // ✅ Grauer 1px Border
            boxShadow: 'medium',  // ✅ Medium Shadow
            // ✅ Cell Defaults
            cellDefaultBackground: 'transparent',
            cellDefaultPadding: 0,  // ✅ Kein Padding in Cells
            cellDefaultPaddingMobile: 0,
            cellDefaultBorderRadius: 0,
            cellDefaultBorderEnabled: false,
            cellDefaultBoxShadow: 'none',
            cellDefaultFlexDirection: 'column',
            cellDefaultAlignItems: 'flex-start',  // ✅ Links ausgerichtet
            cellDefaultJustifyContent: 'center',  // ✅ Vertikal zentriert
            children: [
                // ✅ CELL 1: Image (Links)
                {
                    type: 'cell',
                    cellIndex: 0,
                    alignItems: 'center',  // ✅ Zentriert das Bild horizontal (Desktop)
                    alignItemsMobile: 'center',  // ✅ Auch mobile zentriert
                    justifyContent: 'center',  // ✅ Zentriert das Bild vertikal (Desktop)
                    justifyContentMobile: 'center',  // ✅ Auch mobile zentriert
                    children: [
                        {
                            type: 'image',
                            imageUrl: '/img/yoga.webp',  // ✅ Placeholder Image
                            width: 200,  // ✅ 200px Breite
                            widthType: 'pixel',
                            widthMobile: 200,  // ✅ Auch mobile 200px
                            widthTypeMobile: 'pixel',
                            height: 200,  // ✅ 200px Höhe (quadratisch)
                            heightType: 'pixel',
                            heightMobile: 200,  // ✅ Auch mobile 200px
                            heightTypeMobile: 'pixel',
                            objectFit: 'cover',
                            alignment: 'center',  // ✅ Mittig aligned
                            borderRadius: 100,  // ✅ 100px = Komplett rund bei 200x200px!
                            borderRadiusMobile: 100,  // ✅ Auch mobile komplett rund
                            borderEnabled: true,
                            borderWidth: 1,  // ✅ 1px weißer Border
                            borderColor: '#ffffff',  // ✅ Weiß
                            shadowEnabled: true,
                            shadowIntensity: 20,  // ✅ Etwas stärker für runde Form
                            shadowDistance: 6,
                            shadowOpacity: 20,
                            marginTop: 0,
                            marginBottom: 0,
                            marginLeft: 0,
                            marginRight: 0
                        }
                    ]
                },
                // ✅ CELL 2: Text Content (Rechts - linksbündig)
                {
                    type: 'cell',
                    cellIndex: 1,
                    alignItems: 'flex-start',  // ✅ Linksbündig
                    justifyContent: 'center',  // ✅ Vertikal zentriert
                    children: [
                        // ✅ Meta Text (über dem Title)
                        {
                            type: 'text',
                            elementType: 'p',
                            content: '1. CHAPTER | 50 MINUTES',
                            fontSize: 13,
                            fontSizeMobile: 12,
                            fontWeight: '600',
                            fontWeightMobile: '600',
                            textAlign: 'left',
                            textAlignMobile: 'center',  // ✅ Mobile: Zentriert
                            color: '#888888',  // ✅ Grau für Meta-Text
                            lineHeight: 1.4,
                            lineHeightMobile: 1.4,
                            letterSpacing: 1,
                            letterSpacingMobile: 1,
                            marginTop: 0,
                            marginTopMobile: 20,  // ✅ Mobile: 20px Abstand nach oben
                            marginBottom: 8,
                            marginBottomMobile: 6,
                            marginLeft: 0,
                            marginRight: 0
                        },
                        // ✅ Title
                        {
                            type: 'text',
                            elementType: 'h2',
                            content: 'Discover Our Story',
                            fontSize: 32,
                            fontSizeMobile: 28,
                            fontWeight: '700',
                            fontWeightMobile: '700',
                            textAlign: 'left',
                            textAlignMobile: 'center',  // ✅ Mobile: Zentriert
                            color: '#1a1a1a',  // ✅ Wird durch Brand Colors überschrieben
                            lineHeight: 1.2,
                            lineHeightMobile: 1.2,
                            marginTop: 0,
                            marginBottom: 12,
                            marginBottomMobile: 10,
                            marginLeft: 0,
                            marginRight: 0
                        },
                        // ✅ Description
                        {
                            type: 'text',
                            elementType: 'p',
                            content: 'We are passionate about creating amazing experiences that delight our customers. Our journey started with a simple idea and has grown into something truly special. Join us as we continue to innovate and push boundaries.',
                            fontSize: 16,
                            fontSizeMobile: 15,
                            fontWeight: '400',
                            fontWeightMobile: '400',
                            textAlign: 'left',
                            textAlignMobile: 'center',  // ✅ Mobile: Zentriert
                            color: '#666666',  // ✅ Wird durch Brand Colors überschrieben
                            lineHeight: 1.6,
                            lineHeightMobile: 1.6,
                            marginTop: 0,
                            marginBottom: 0,
                            marginLeft: 0,
                            marginRight: 0
                        }
                    ]
                }
            ]
        }
    },

    // 🎯 PRODUCT FEATURES (4 Columns)
    'product-features-4': {
        name: 'Product Features (4 Columns)',
        description: '4 Features with FontAwesome icons, title, and description',
        icon: 'fa-th',
        category: 'features',
        grid: {
            columns: 4,
            gap: 20,
            gapMobile: 15,
            columnTemplate: 'equal',
            marginTop: 40,
            marginBottom: 40,
            maxWidth: 1200,  // ✅ Max Width für zentriertes Layout
            maxWidthMobile: 900,  // ✅ Mobile Max Width
            gridDirection: 'horizontal',
            gridDirectionMobile: 'vertical', // Mobile: Stack vertical
            cellDefaultBackground: '#f8f9ff',  // ✅ Wird durch Brand Colors überschrieben
            cellDefaultPadding: 24,
            cellDefaultPaddingMobile: 20,
            cellDefaultBorderRadius: 20,
            cellDefaultBorderEnabled: false,  // ✅ Kein Border auf Cells
            cellDefaultBorderWidth: 1,
            cellDefaultBorderColor: 'rgba(102, 126, 234, 0.15)',
            cellDefaultBoxShadow: 'none',  // ✅ Kein Shadow auf Cells
            boxShadow: 'small',  // ✅ Grid Shadow (am äußeren Container!)
            cellDefaultFlexDirection: 'column',
            cellDefaultAlignItems: 'center',
            cellDefaultJustifyContent: 'flex-start',
            children: [
                {
                    type: 'cell',
                    cellIndex: 0,
                    children: [
                        {
                            type: 'image',
                            imageUrl: '/img/money.svg',  // ✅ Custom Icon
                            width: 24,  // ✅ Icon Größe
                            widthType: 'pixel',
                            height: 24,
                            heightType: 'pixel',
                            objectFit: 'contain',
                            alignment: 'center',
                            borderRadius: 50,  // ✅ Rund
                            containerBgColor: '#667eea',  // ✅ Fallback - wird durch Brand Colors überschrieben
                            iconContainerSize: 64,  // ✅ Icon Mode aktiviert!
                            iconContainerSizeMobile: 56,
                            padding: 0,
                            paddingMobile: 0,
                            borderEnabled: false,
                            shadowEnabled: false,
                            invertColors: false,  // ✅ Wird dynamisch gesetzt
                            marginBottom: 20,
                            marginTop: 0,
                            marginLeft: 0,
                            marginRight: 0
                        },
                        {
                            type: 'text',
                            elementType: 'h3',
                            content: 'Lightning Fast',
                            fontSize: 22,
                            fontSizeMobile: 20,
                            fontWeight: '700',
                            textAlign: 'center',
                            color: '#1a1a1a',  // ✅ Wird durch Brand Colors überschrieben
                            marginBottom: 12
                        },
                        {
                            type: 'text',
                            elementType: 'p',
                            content: 'Experience blazing fast load times and instant responsiveness that keeps your users engaged and happy.',
                            fontSize: 15,
                            fontSizeMobile: 14,
                            fontWeight: '400',
                            textAlign: 'center',
                            color: '#666666',
                            lineHeight: 1.6
                        }
                    ]
                },
                {
                    type: 'cell',
                    cellIndex: 1,
                    children: [
                        {
                            type: 'image',
                            imageUrl: '/img/key.png',  // ✅ Custom Icon
                            width: 24,
                            widthType: 'pixel',
                            height: 24,
                            heightType: 'pixel',
                            objectFit: 'contain',
                            alignment: 'center',
                            borderRadius: 50,  // ✅ Rund
                            containerBgColor: '#667eea',  // ✅ Fallback
                            iconContainerSize: 64,  // ✅ Icon Mode!
                            iconContainerSizeMobile: 56,
                            padding: 0,
                            paddingMobile: 0,
                            borderEnabled: false,
                            shadowEnabled: false,
                            invertColors: false,
                            marginBottom: 20,
                            marginTop: 0,
                            marginLeft: 0,
                            marginRight: 0
                        },
                        {
                            type: 'text',
                            elementType: 'h3',
                            content: 'Secure & Safe',
                            fontSize: 22,
                            fontSizeMobile: 20,
                            fontWeight: '700',
                            textAlign: 'center',
                            color: '#1a1a1a',
                            marginBottom: 12
                        },
                        {
                            type: 'text',
                            elementType: 'p',
                            content: 'Bank-level security with end-to-end encryption ensures your data stays protected and private at all times.',
                            fontSize: 15,
                            fontSizeMobile: 14,
                            fontWeight: '400',
                            textAlign: 'center',
                            color: '#666666',
                            lineHeight: 1.6
                        }
                    ]
                },
                {
                    type: 'cell',
                    cellIndex: 2,
                    children: [
                        {
                            type: 'image',
                            imageUrl: '/img/heart-four.svg',  // ✅ Custom Icon
                            width: 24,
                            widthType: 'pixel',
                            height: 24,
                            heightType: 'pixel',
                            objectFit: 'contain',
                            alignment: 'center',
                            borderRadius: 50,  // ✅ Rund
                            containerBgColor: '#667eea',  // ✅ Fallback
                            iconContainerSize: 64,  // ✅ Icon Mode!
                            iconContainerSizeMobile: 56,
                            padding: 0,
                            paddingMobile: 0,
                            borderEnabled: false,
                            shadowEnabled: false,
                            invertColors: false,
                            marginBottom: 20,
                            marginTop: 0,
                            marginLeft: 0,
                            marginRight: 0
                        },
                        {
                            type: 'text',
                            elementType: 'h3',
                            content: 'Easy to Use',
                            fontSize: 22,
                            fontSizeMobile: 20,
                            fontWeight: '700',
                            textAlign: 'center',
                            color: '#1a1a1a',
                            marginBottom: 12
                        },
                        {
                            type: 'text',
                            elementType: 'p',
                            content: 'Intuitive design and simple navigation make it easy for anyone to get started without a learning curve.',
                            fontSize: 15,
                            fontSizeMobile: 14,
                            fontWeight: '400',
                            textAlign: 'center',
                            color: '#666666',
                            lineHeight: 1.6
                        }
                    ]
                },
                {
                    type: 'cell',
                    cellIndex: 3,
                    children: [
                        {
                            type: 'image',
                            imageUrl: '/img/eye.png',  // ✅ Custom Icon
                            width: 24,
                            widthType: 'pixel',
                            height: 24,
                            heightType: 'pixel',
                            objectFit: 'contain',
                            alignment: 'center',
                            borderRadius: 50,  // ✅ Rund
                            containerBgColor: '#667eea',  // ✅ Fallback
                            iconContainerSize: 64,  // ✅ Icon Mode!
                            iconContainerSizeMobile: 56,
                            padding: 0,
                            paddingMobile: 0,
                            borderEnabled: false,
                            shadowEnabled: false,
                            invertColors: false,
                            marginBottom: 20,
                            marginTop: 0,
                            marginLeft: 0,
                            marginRight: 0
                        },
                        {
                            type: 'text',
                            elementType: 'h3',
                            content: 'Built with Care',
                            fontSize: 22,
                            fontSizeMobile: 20,
                            fontWeight: '700',
                            textAlign: 'center',
                            color: '#1a1a1a',
                            marginBottom: 12
                        },
                        {
                            type: 'text',
                            elementType: 'p',
                            content: 'Crafted with attention to detail and passion, delivering a polished experience that users love and trust.',
                            fontSize: 15,
                            fontSizeMobile: 14,
                            fontWeight: '400',
                            textAlign: 'center',
                            color: '#666666',
                            lineHeight: 1.6
                        }
                    ]
                }
            ]
        }
    },

    // 🖼️ IMAGE GALLERY (3 Columns)
    'image-gallery-3': {
        name: 'Image Gallery (3 Columns)',
        description: 'Image grid with captions',
        icon: 'fa-images',
        category: 'media',
        grid: {
            columns: 3,
            gap: 16,
            gapMobile: 12,
            columnTemplate: 'equal',
            marginTop: 30,
            marginBottom: 30,
            maxWidth: 1100,  // ✅ Max Width für Gallery
            maxWidthMobile: 800,  // ✅ Mobile Max Width
            gridDirection: 'horizontal',
            gridDirectionMobile: 'vertical',
            cellDefaultBackground: 'transparent',
            cellDefaultPadding: 0,
            cellDefaultPaddingMobile: 0,
            cellDefaultBorderRadius: 12,
            cellDefaultBorderEnabled: false,
            cellDefaultFlexDirection: 'column',
            cellDefaultAlignItems: 'stretch',
            cellDefaultJustifyContent: 'flex-start',
            children: [
                {
                    type: 'cell',
                    cellIndex: 0,
                    children: [
                        {
                            type: 'image',
                            imageUrl: '/img/yoga.webp',
                            width: 100,
                            widthType: 'percent',
                            height: 300,
                            heightType: 'pixel',
                            objectFit: 'cover',
                            alignment: 'center',
                            borderRadius: 12,
                            marginBottom: 12,
                            marginLeft: 0,
                            marginRight: 0
                        },
                        {
                            type: 'text',
                            elementType: 'h3',
                            content: 'Image Title',
                            fontSize: 18,
                            fontSizeMobile: 16,
                            fontWeight: '600',
                            textAlign: 'center',
                            marginBottom: 4
                        },
                        {
                            type: 'text',
                            elementType: 'p',
                            content: 'Short caption',
                            fontSize: 14,
                            fontSizeMobile: 13,
                            fontWeight: '400',
                            textAlign: 'center',
                            color: '#888888'
                        }
                    ]
                },
                {
                    type: 'cell',
                    cellIndex: 1,
                    children: [
                        {
                            type: 'image',
                            imageUrl: '/img/foto1.jpg',
                            width: 100,
                            widthType: 'percent',
                            height: 300,
                            heightType: 'pixel',
                            objectFit: 'cover',
                            alignment: 'center',
                            borderRadius: 12,
                            marginBottom: 12,
                            marginLeft: 0,
                            marginRight: 0
                        },
                        {
                            type: 'text',
                            elementType: 'h3',
                            content: 'Image Title',
                            fontSize: 18,
                            fontSizeMobile: 16,
                            fontWeight: '600',
                            textAlign: 'center',
                            marginBottom: 4
                        },
                        {
                            type: 'text',
                            elementType: 'p',
                            content: 'Short caption',
                            fontSize: 14,
                            fontSizeMobile: 13,
                            fontWeight: '400',
                            textAlign: 'center',
                            color: '#888888'
                        }
                    ]
                },
                {
                    type: 'cell',
                    cellIndex: 2,
                    children: [
                        {
                            type: 'image',
                            imageUrl: '/img/foto2.jpg',
                            width: 100,
                            widthType: 'percent',
                            height: 300,
                            heightType: 'pixel',
                            objectFit: 'cover',
                            alignment: 'center',
                            borderRadius: 12,
                            marginBottom: 12,
                            marginLeft: 0,
                            marginRight: 0
                        },
                        {
                            type: 'text',
                            elementType: 'h3',
                            content: 'Image Title',
                            fontSize: 18,
                            fontSizeMobile: 16,
                            fontWeight: '600',
                            textAlign: 'center',
                            marginBottom: 4
                        },
                        {
                            type: 'text',
                            elementType: 'p',
                            content: 'Short caption',
                            fontSize: 14,
                            fontSizeMobile: 13,
                            fontWeight: '400',
                            textAlign: 'center',
                            color: '#888888'
                        }
                    ]
                }
            ]
        }
    },

    // ✅ SIMPLE CHECKLIST - Checkbox + Text in GLEICHER Cell!
    'premium-checklist-straight': {
        name: 'Premium Checklist (Straight)',
        description: 'Premium checklist with straight edges, borders, icons, title and description',
        icon: 'fa-list-check',
        category: 'features',
        grid: {
            columns: 1,  // ✅ 1 Column für clean Layout
            gap: 12,
            gapMobile: 10,
            columnTemplate: 'equal',
            marginTop: 30,
            marginBottom: 30,
            maxWidth: 800,  // ✅ Max Width für Checklist
            maxWidthMobile: 650,  // ✅ Mobile Max Width
            gridDirection: 'horizontal',
            gridDirectionMobile: 'horizontal',
            cellDefaultBackground: '#ffffff',
            cellDefaultPadding: 20,  // ✅ Mehr Padding für Premium Look
            cellDefaultPaddingMobile: 16,
            cellDefaultBorderRadius: 1,  // ✅ 1px Border Radius (subtle auf Cells)
            cellDefaultBorderEnabled: false,  // ✅ KEIN Border auf einzelnen Cells/Rows!
            cellDefaultBorderWidth: 1,
            cellDefaultBorderColor: 'rgba(0, 0, 0, 0.1)',
            cellDefaultBoxShadow: 'none',  // ✅ KEINE Schatten auf einzelnen Cells/Rows!
            // ✅ Grid Border & Shadow (am äußeren Container!)
            borderEnabled: true,  // ✅ Border aktiviert
            borderWidth: 1,
            borderColor: 'rgba(0, 0, 0, 0.1)',
            borderRadius: 1,  // ✅ 1px Border Radius am Grid Container
            boxShadow: 'small',  // ✅ Grid Shadow (nur am äußeren Container!)
            // ✅ Row Content (Icon + Text Column)
            cellDefaultFlexDirection: 'row',
            cellDefaultFlexDirectionMobile: 'row',
            cellDefaultAlignItems: 'center',  // ✅ CENTER aligned - Icon und Text auf gleicher Höhe
            cellDefaultJustifyContent: 'flex-start',
            cellDefaultGap: 16,  // ✅ Gap zwischen Icon und Text-Block
            cellDefaultGapMobile: 14,
            children: [
                // Row 1
                {
                    type: 'cell',
                    cellIndex: 0,
                    children: [
                        {
                            type: 'image',
                            imageUrl: '/img/done.svg',
                            width: 20,
                            widthType: 'pixel',
                            height: 20,
                            heightType: 'pixel',
                            objectFit: 'contain',
                            alignment: 'left',
                            borderRadius: 0,  // ✅ SQUARE ICON CONTAINER!
                            containerBgColor: '#1a202c',  // ✅ Fallback - wird durch Brand Colors überschrieben
                            iconContainerSize: 40,  // ✅ Icon Mode aktiviert
                            iconContainerSizeMobile: 36,
                            padding: 0,
                            paddingMobile: 0,
                            borderEnabled: false,
                            shadowEnabled: false,
                            invertColors: true,  // ✅ Wird dynamisch gesetzt, aber Fallback auf true
                            marginBottom: 0,
                            marginTop: 0,
                            marginLeft: 0,
                            marginRight: 0
                        },
                        // ✅ TEXT COLUMN: Title + Description (innere Grid-Cell - KEIN Shadow!)
                        {
                            type: 'grid',
                            columns: 1,
                            gap: 6,
                            gapMobile: 6,
                            columnTemplate: 'equal',
                            marginTop: 0,
                            marginBottom: 0,
                            gridDirection: 'horizontal',
                            cellDefaultBackground: 'transparent',  // ✅ Kein Background!
                            cellDefaultPadding: 0,
                            cellDefaultBorderRadius: 0,  // ✅ Kein Border Radius für Text-Container
                            cellDefaultBorderEnabled: false,  // ✅ Kein Border
                            cellDefaultBoxShadow: 'none',  // ✅ KEIN Shadow - nur äußere Cell!
                            cellDefaultFlexDirection: 'column',
                            cellDefaultAlignItems: 'flex-start',
                            cellDefaultJustifyContent: 'center',  // ✅ Vertikal centered
                            children: [
                                {
                                    type: 'cell',
                                    cellIndex: 0,
                                    children: [
                                        {
                                            type: 'text',
                                            elementType: 'h3',
                                            content: 'Premium Support',
                                            fontSize: 18,
                                            fontSizeMobile: 16,
                                            fontWeight: '600',
                                            textAlign: 'left',
                                            color: '#1a202c',  // ✅ Fallback - wird durch Brand Colors überschrieben
                                            lineHeight: 1.3,
                                            marginTop: 0,
                                            marginBottom: 0,
                                            marginLeft: 0,
                                            marginRight: 0
                                        },
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: 'Dedicated account manager for all your needs',
                                            fontSize: 14,
                                            fontSizeMobile: 13,
                                            fontWeight: '400',
                                            textAlign: 'left',
                                            color: '#4a5568',  // ✅ Fallback - bleibt grau für Hierarchie
                                            lineHeight: 1.6,
                                            marginTop: 0,
                                            marginBottom: 0,
                                            marginLeft: 0,
                                            marginRight: 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                // Row 2
                {
                    type: 'cell',
                    cellIndex: 1,
                    children: [
                        {
                            type: 'image',
                            imageUrl: '/img/done.svg',
                            width: 20,
                            widthType: 'pixel',
                            height: 20,
                            heightType: 'pixel',
                            objectFit: 'contain',
                            alignment: 'left',
                            borderRadius: 0,
                            containerBgColor: '#1a202c',
                            iconContainerSize: 40,
                            iconContainerSizeMobile: 36,
                            padding: 0,
                            paddingMobile: 0,
                            borderEnabled: false,
                            shadowEnabled: false,
                            marginBottom: 0,
                            marginTop: 0,
                            marginLeft: 0,
                            marginRight: 0
                        },
                        {
                            type: 'grid',
                            columns: 1,
                            gap: 6,
                            gapMobile: 6,
                            columnTemplate: 'equal',
                            marginTop: 0,
                            marginBottom: 0,
                            gridDirection: 'horizontal',
                            cellDefaultBackground: 'transparent',
                            cellDefaultPadding: 0,
                            cellDefaultBorderRadius: 0,
                            cellDefaultBorderEnabled: false,
                            cellDefaultBoxShadow: 'none',  // ✅ KEIN Shadow - nur äußere Cell!
                            cellDefaultFlexDirection: 'column',
                            cellDefaultAlignItems: 'flex-start',
                            cellDefaultJustifyContent: 'flex-start',
                            children: [
                                {
                                    type: 'cell',
                                    cellIndex: 0,
                                    children: [
                                        {
                                            type: 'text',
                                            elementType: 'h3',
                                            content: 'Advanced Analytics',
                                            fontSize: 18,
                                            fontSizeMobile: 16,
                                            fontWeight: '600',
                                            textAlign: 'left',
                                            color: '#1a202c',  // ✅ Fallback
                                            lineHeight: 1.3,
                                            marginTop: 0,
                                            marginBottom: 0,
                                            marginLeft: 0,
                                            marginRight: 0
                                        },
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: 'Comprehensive reporting dashboard and insights',
                                            fontSize: 14,
                                            fontSizeMobile: 13,
                                            fontWeight: '400',
                                            textAlign: 'left',
                                            color: '#4a5568',  // ✅ Fallback
                                            lineHeight: 1.6,
                                            marginTop: 0,
                                            marginBottom: 0,
                                            marginLeft: 0,
                                            marginRight: 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                // Row 3
                {
                    type: 'cell',
                    cellIndex: 2,
                    children: [
                        {
                            type: 'image',
                            imageUrl: '/img/done.svg',
                            width: 20,
                            widthType: 'pixel',
                            height: 20,
                            heightType: 'pixel',
                            objectFit: 'contain',
                            alignment: 'left',
                            borderRadius: 0,
                            containerBgColor: '#1a202c',
                            iconContainerSize: 40,
                            iconContainerSizeMobile: 36,
                            padding: 0,
                            paddingMobile: 0,
                            borderEnabled: false,
                            shadowEnabled: false,
                            marginBottom: 0,
                            marginTop: 0,
                            marginLeft: 0,
                            marginRight: 0
                        },
                        {
                            type: 'grid',
                            columns: 1,
                            gap: 6,
                            gapMobile: 6,
                            columnTemplate: 'equal',
                            marginTop: 0,
                            marginBottom: 0,
                            gridDirection: 'horizontal',
                            cellDefaultBackground: 'transparent',
                            cellDefaultPadding: 0,
                            cellDefaultBorderRadius: 0,
                            cellDefaultBorderEnabled: false,
                            cellDefaultBoxShadow: 'none',  // ✅ KEIN Shadow - nur äußere Cell!
                            cellDefaultFlexDirection: 'column',
                            cellDefaultAlignItems: 'flex-start',
                            cellDefaultJustifyContent: 'flex-start',
                            children: [
                                {
                                    type: 'cell',
                                    cellIndex: 0,
                                    children: [
                                        {
                                            type: 'text',
                                            elementType: 'h3',
                                            content: 'Unlimited Storage',
                                            fontSize: 18,
                                            fontSizeMobile: 16,
                                            fontWeight: '600',
                                            textAlign: 'left',
                                            color: '#1a202c',  // ✅ Fallback
                                            lineHeight: 1.3,
                                            marginTop: 0,
                                            marginBottom: 0,
                                            marginLeft: 0,
                                            marginRight: 0
                                        },
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: 'Storage and bandwidth with no restrictions',
                                            fontSize: 14,
                                            fontSizeMobile: 13,
                                            fontWeight: '400',
                                            textAlign: 'left',
                                            color: '#4a5568',  // ✅ Fallback
                                            lineHeight: 1.6,
                                            marginTop: 0,
                                            marginBottom: 0,
                                            marginLeft: 0,
                                            marginRight: 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                // Row 4
                {
                    type: 'cell',
                    cellIndex: 3,
                    children: [
                        {
                            type: 'image',
                            imageUrl: '/img/done.svg',
                            width: 20,
                            widthType: 'pixel',
                            height: 20,
                            heightType: 'pixel',
                            objectFit: 'contain',
                            alignment: 'left',
                            borderRadius: 0,
                            containerBgColor: '#1a202c',
                            iconContainerSize: 40,
                            iconContainerSizeMobile: 36,
                            padding: 0,
                            paddingMobile: 0,
                            borderEnabled: false,
                            shadowEnabled: false,
                            marginBottom: 0,
                            marginTop: 0,
                            marginLeft: 0,
                            marginRight: 0
                        },
                        {
                            type: 'grid',
                            columns: 1,
                            gap: 6,
                            gapMobile: 6,
                            columnTemplate: 'equal',
                            marginTop: 0,
                            marginBottom: 0,
                            gridDirection: 'horizontal',
                            cellDefaultBackground: 'transparent',
                            cellDefaultPadding: 0,
                            cellDefaultBorderRadius: 0,
                            cellDefaultBorderEnabled: false,
                            cellDefaultBoxShadow: 'none',  // ✅ KEIN Shadow - nur äußere Cell!
                            cellDefaultFlexDirection: 'column',
                            cellDefaultAlignItems: 'flex-start',
                            cellDefaultJustifyContent: 'flex-start',
                            children: [
                                {
                                    type: 'cell',
                                    cellIndex: 0,
                                    children: [
                                        {
                                            type: 'text',
                                            elementType: 'h3',
                                            content: '24/7 Support',
                                            fontSize: 18,
                                            fontSizeMobile: 16,
                                            fontWeight: '600',
                                            textAlign: 'left',
                                            color: '#1a202c',  // ✅ Fallback
                                            lineHeight: 1.3,
                                            marginTop: 0,
                                            marginBottom: 0,
                                            marginLeft: 0,
                                            marginRight: 0
                                        },
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: 'Customer support via chat, email, and phone',
                                            fontSize: 14,
                                            fontSizeMobile: 13,
                                            fontWeight: '400',
                                            textAlign: 'left',
                                            color: '#4a5568',  // ✅ Fallback
                                            lineHeight: 1.6,
                                            marginTop: 0,
                                            marginBottom: 0,
                                            marginLeft: 0,
                                            marginRight: 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    
    // ✅ PREMIUM CHECKLIST - Edel mit Rahmen und rundem Icon Background
    'premium-checklist': {
        name: 'Premium Checklist',
        description: 'Elegant checklist with rounded icon background and borders',
        icon: 'fa-check-circle',
        category: 'features',
        grid: {
            columns: 1,  // ✅ 1 Column für clean Layout
            gap: 10,
            gapMobile: 8,
            columnTemplate: 'equal',
            marginTop: 30,
            marginBottom: 30,
            maxWidth: 800,  // ✅ Max Width für Checklist
            maxWidthMobile: 650,  // ✅ Mobile Max Width
            gridDirection: 'horizontal',  // ✅ Rows untereinander
            gridDirectionMobile: 'horizontal',
            cellDefaultBackground: '#ffffff',  // ✅ Weiß für edlen Look
            cellDefaultPadding: 16,  // ✅ Mehr Padding für edlen Look
            cellDefaultPaddingMobile: 14,
            cellDefaultBorderRadius: 12,  // ✅ Abgerundete Ecken
            cellDefaultBorderEnabled: true,  // ✅ Border aktiviert!
            cellDefaultBorderWidth: 1,
            cellDefaultBorderColor: 'rgba(102, 126, 234, 0.15)',  // ✅ Subtiler lila Border
            cellDefaultBoxShadow: 'small',  // ✅ Leichter Schatten für Tiefe
            // ✅ Row Content (Icon + Text horizontal)
            cellDefaultFlexDirection: 'row',
            cellDefaultFlexDirectionMobile: 'row',
            cellDefaultAlignItems: 'center',  // ✅ Center aligned
            cellDefaultJustifyContent: 'flex-start',
            cellDefaultGap: 16,  // ✅ Mehr Gap für edlen Look
            cellDefaultGapMobile: 14,
            children: [
                // Row 1
                {
                    type: 'cell',
                    cellIndex: 0,
                    children: [
                        {
                            type: 'image',
                            imageUrl: '/img/done.svg',
                            width: 20,  // ✅ Icon Größe
                            widthType: 'pixel',
                            height: 20,
                            heightType: 'pixel',
                            objectFit: 'contain',
                            alignment: 'center',
                            borderRadius: 50,  // ✅ RUND!
                            containerBgColor: '#667eea',  // ✅ Fallback - wird durch Brand Colors überschrieben
                            iconContainerSize: 40,  // ✅ Icon Mode aktiviert
                            iconContainerSizeMobile: 36,
                            padding: 0,
                            paddingMobile: 0,
                            borderEnabled: false,
                            shadowEnabled: false,
                            marginBottom: 0,
                            marginTop: 0,
                            marginLeft: 0,
                            marginRight: 0
                        },
                        {
                            type: 'text',
                            elementType: 'p',
                            content: 'Premium support and dedicated account manager for all your needs',
                            fontSize: 16,
                            fontSizeMobile: 15,
                            fontWeight: '500',
                            textAlign: 'left',
                            color: '#333333',
                            lineHeight: 1.5,
                            marginTop: 0,
                            marginBottom: 0,
                            marginLeft: 0,
                            marginRight: 0
                        }
                    ]
                },
                // Row 2
                {
                    type: 'cell',
                    cellIndex: 1,
                    children: [
                        {
                            type: 'image',
                            imageUrl: '/img/done.svg',
                            width: 20,  // ✅ Icon Größe
                            widthType: 'pixel',
                            height: 20,
                            heightType: 'pixel',
                            objectFit: 'contain',
                            alignment: 'center',
                            borderRadius: 50,  // ✅ RUND!
                            containerBgColor: '#667eea',  // ✅ Fallback - wird durch Brand Colors überschrieben
                            iconContainerSize: 40,  // ✅ Icon Mode aktiviert
                            iconContainerSizeMobile: 36,
                            padding: 0,
                            paddingMobile: 0,
                            borderEnabled: false,
                            shadowEnabled: false,
                            marginBottom: 0,
                            marginTop: 0,
                            marginLeft: 0,
                            marginRight: 0
                        },
                        {
                            type: 'text',
                            elementType: 'p',
                            content: 'Advanced analytics and comprehensive reporting dashboard',
                            fontSize: 16,
                            fontSizeMobile: 15,
                            fontWeight: '500',
                            textAlign: 'left',
                            color: '#333333',
                            lineHeight: 1.5,
                            marginTop: 0,
                            marginBottom: 0,
                            marginLeft: 0,
                            marginRight: 0
                        }
                    ]
                },
                // Row 3
                {
                    type: 'cell',
                    cellIndex: 2,
                    children: [
                        {
                            type: 'image',
                            imageUrl: '/img/done.svg',
                            width: 20,  // ✅ Icon Größe
                            widthType: 'pixel',
                            height: 20,
                            heightType: 'pixel',
                            objectFit: 'contain',
                            alignment: 'center',
                            borderRadius: 50,  // ✅ RUND!
                            containerBgColor: '#667eea',  // ✅ Fallback - wird durch Brand Colors überschrieben
                            iconContainerSize: 40,  // ✅ Icon Mode aktiviert
                            iconContainerSizeMobile: 36,
                            padding: 0,
                            paddingMobile: 0,
                            borderEnabled: false,
                            shadowEnabled: false,
                            marginBottom: 0,
                            marginTop: 0,
                            marginLeft: 0,
                            marginRight: 0
                        },
                        {
                            type: 'text',
                            elementType: 'p',
                            content: 'Unlimited storage and bandwidth with no restrictions',
                            fontSize: 16,
                            fontSizeMobile: 15,
                            fontWeight: '500',
                            textAlign: 'left',
                            color: '#333333',
                            lineHeight: 1.5,
                            marginTop: 0,
                            marginBottom: 0,
                            marginLeft: 0,
                            marginRight: 0
                        }
                    ]
                },
                // Row 4
                {
                    type: 'cell',
                    cellIndex: 3,
                    children: [
                        {
                            type: 'image',
                            imageUrl: '/img/done.svg',
                            width: 20,  // ✅ Icon Größe
                            widthType: 'pixel',
                            height: 20,
                            heightType: 'pixel',
                            objectFit: 'contain',
                            alignment: 'center',
                            borderRadius: 50,  // ✅ RUND!
                            containerBgColor: '#667eea',  // ✅ Fallback - wird durch Brand Colors überschrieben
                            iconContainerSize: 40,  // ✅ Icon Mode aktiviert
                            iconContainerSizeMobile: 36,
                            padding: 0,
                            paddingMobile: 0,
                            borderEnabled: false,
                            shadowEnabled: false,
                            marginBottom: 0,
                            marginTop: 0,
                            marginLeft: 0,
                            marginRight: 0
                        },
                        {
                            type: 'text',
                            elementType: 'p',
                            content: '24/7 customer support via chat, email, and phone',
                            fontSize: 16,
                            fontSizeMobile: 15,
                            fontWeight: '500',
                            textAlign: 'left',
                            color: '#333333',
                            lineHeight: 1.5,
                            marginTop: 0,
                            marginBottom: 0,
                            marginLeft: 0,
                            marginRight: 0
                        }
                    ]
                }
            ]
        }
    },

    
    // ✅ FEATURE LIST (Checkmarks) - Nested Grid für kompakte Liste
    'feature-list': {
        name: 'Feature List (Checkmarks)',
        description: 'Compact vertical list with checkmarks',
        icon: 'fa-check-circle',
        category: 'features',
        grid: {
            columns: 1,
            gap: 0,
            gapMobile: 0,
            columnTemplate: 'equal',
            marginTop: 20,
            marginBottom: 20,
            maxWidth: 700,  // ✅ Max Width für kompakte Liste
            maxWidthMobile: 600,  // ✅ Mobile Max Width
            gridDirection: 'vertical',  // ✅ FIXED: Vertical da nur 1 Spalte
            gridDirectionMobile: 'vertical',  // ✅ FIXED: Auch mobile vertikal
            cellDefaultBackground: 'transparent',
            cellDefaultPadding: 0,
            cellDefaultPaddingMobile: 0,
            cellDefaultBorderRadius: 0,
            cellDefaultBorderEnabled: false,
            cellDefaultFlexDirection: 'column',
            cellDefaultAlignItems: 'stretch',
            cellDefaultJustifyContent: 'flex-start',
            children: [
                {
                    type: 'cell',
                    cellIndex: 0,
                    children: [
                        // ✅ NESTED GRID - Kompakte Feature-Liste
                        {
                            type: 'grid',
                            columns: 1,
                            gap: 6, // ✅ Sehr kleiner Gap (6px zwischen Features)
                            gapMobile: 6,
                            columnTemplate: 'equal',
                            marginTop: 0,
                            marginBottom: 0,
                            gridDirection: 'vertical',  // ✅ FIXED: Vertical für untereinander (da 1 Spalte)
                            gridDirectionMobile: 'vertical',  // ✅ FIXED: Auch mobile vertikal
                            // ✅ Inner Grid Cells: Horizontal Layout mit Icon links + Text rechts
                            cellDefaultBackground: 'rgba(102, 126, 234, 0.03)', // ✅ Sehr subtiler Background
                            cellDefaultPadding: 12,
                            cellDefaultPaddingMobile: 10,
                            cellDefaultBorderRadius: 8,
                            cellDefaultBorderEnabled: false,
                            cellDefaultFlexDirection: 'row', // ✅ HORIZONTAL!
                            cellDefaultAlignItems: 'flex-start', // ✅ Top aligned (für multi-line text)
                            cellDefaultJustifyContent: 'flex-start',
                            cellDefaultGap: 12, // ✅ Gap zwischen Icon und Text
                            cellDefaultGapMobile: 12,
                            children: [
                                {
                                    type: 'cell',
                                    cellIndex: 0,
                                    children: [
                                        {
                                            type: 'image',
                                            imageUrl: '/img/done.svg',
                                            width: 20,
                                            widthType: 'pixel',
                                            height: 20,
                                            heightType: 'pixel',
                                            objectFit: 'contain',
                                            alignment: 'left',
                                            marginRight: 12,
                                            marginLeft: 0,
                                            marginTop: 2, // ✅ Slight adjustment for alignment
                                            marginBottom: 0
                                        },
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: 'Premium support and dedicated account manager',
                                            fontSize: 15,
                                            fontSizeMobile: 14,
                                            fontWeight: '500',
                                            textAlign: 'left',
                                            color: '#333333',
                                            lineHeight: 1.5,
                                            marginTop: 0,
                                            marginBottom: 0,
                                            marginLeft: 0,
                                            marginRight: 0
                                        }
                                    ]
                                },
                                {
                                    type: 'cell',
                                    cellIndex: 1,
                                    children: [
                                        {
                                            type: 'image',
                                            imageUrl: '/img/done.svg',
                                            width: 20,
                                            widthType: 'pixel',
                                            height: 20,
                                            heightType: 'pixel',
                                            objectFit: 'contain',
                                            alignment: 'left',
                                            marginRight: 12,
                                            marginLeft: 0,
                                            marginTop: 2,
                                            marginBottom: 0
                                        },
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: 'Advanced analytics and reporting dashboard',
                                            fontSize: 15,
                                            fontSizeMobile: 14,
                                            fontWeight: '500',
                                            textAlign: 'left',
                                            color: '#333333',
                                            lineHeight: 1.5,
                                            marginTop: 0,
                                            marginBottom: 0,
                                            marginLeft: 0,
                                            marginRight: 0
                                        }
                                    ]
                                },
                                {
                                    type: 'cell',
                                    cellIndex: 2,
                                    children: [
                                        {
                                            type: 'image',
                                            imageUrl: '/img/done.svg',
                                            width: 20,
                                            widthType: 'pixel',
                                            height: 20,
                                            heightType: 'pixel',
                                            objectFit: 'contain',
                                            alignment: 'left',
                                            marginRight: 12,
                                            marginLeft: 0,
                                            marginTop: 2,
                                            marginBottom: 0
                                        },
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: 'Unlimited storage and bandwidth included',
                                            fontSize: 15,
                                            fontSizeMobile: 14,
                                            fontWeight: '500',
                                            textAlign: 'left',
                                            color: '#333333',
                                            lineHeight: 1.5,
                                            marginTop: 0,
                                            marginBottom: 0,
                                            marginLeft: 0,
                                            marginRight: 0
                                        }
                                    ]
                                },
                                {
                                    type: 'cell',
                                    cellIndex: 3,
                                    children: [
                                        {
                                            type: 'image',
                                            imageUrl: '/img/done.svg',
                                            width: 20,
                                            widthType: 'pixel',
                                            height: 20,
                                            heightType: 'pixel',
                                            objectFit: 'contain',
                                            alignment: 'left',
                                            marginRight: 12,
                                            marginLeft: 0,
                                            marginTop: 2,
                                            marginBottom: 0
                                        },
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: 'Priority access to new features and updates',
                                            fontSize: 15,
                                            fontSizeMobile: 14,
                                            fontWeight: '500',
                                            textAlign: 'left',
                                            color: '#333333',
                                            lineHeight: 1.5,
                                            marginTop: 0,
                                            marginBottom: 0,
                                            marginLeft: 0,
                                            marginRight: 0
                                        }
                                    ]
                                },
                                {
                                    type: 'cell',
                                    cellIndex: 4,
                                    children: [
                                        {
                                            type: 'image',
                                            imageUrl: '/img/done.svg',
                                            width: 20,
                                            widthType: 'pixel',
                                            height: 20,
                                            heightType: 'pixel',
                                            objectFit: 'contain',
                                            alignment: 'left',
                                            marginRight: 12,
                                            marginLeft: 0,
                                            marginTop: 2,
                                            marginBottom: 0
                                        },
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: '24/7 customer support via chat, email, and phone',
                                            fontSize: 15,
                                            fontSizeMobile: 14,
                                            fontWeight: '500',
                                            textAlign: 'left',
                                            color: '#333333',
                                            lineHeight: 1.5,
                                            marginTop: 0,
                                            marginBottom: 0,
                                            marginLeft: 0,
                                            marginRight: 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },

    // 📝 PRICING TABLE (3 Columns)
    'pricing-3': {
        name: 'Pricing Table (3 Columns)',
        description: 'Pricing cards with features and brand colors',
        icon: 'fa-dollar-sign',
        category: 'pricing',
        grid: {
            columns: 3,
            gap: 20,
            gapMobile: 16,
            columnTemplate: 'equal',
            marginTop: 40,
            marginBottom: 40,
            maxWidth: 1100,  // ✅ Max Width für Pricing Cards
            maxWidthMobile: 900,  // ✅ Mobile Max Width
            gridDirection: 'horizontal',
            gridDirectionMobile: 'vertical',
            cellDefaultBackground: '#ffffff',  // ✅ Wird durch Brand Colors überschrieben
            cellDefaultPadding: 32,
            cellDefaultPaddingMobile: 24,
            cellDefaultBorderRadius: 16,
            cellDefaultBorderEnabled: false,  // ✅ Kein Border auf Cells
            cellDefaultBorderWidth: 2,
            cellDefaultBorderColor: '#e0e0e0',
            cellDefaultBoxShadow: 'medium',  // ✅ Medium Shadow für Pricing Cards
            cellDefaultFlexDirection: 'column',
            cellDefaultAlignItems: 'center',
            cellDefaultJustifyContent: 'flex-start',
            children: [
                {
                    type: 'cell',
                    cellIndex: 0,
                    children: [
                        {
                            type: 'text',
                            elementType: 'h3',
                            content: 'Basic',
                            fontSize: 24,
                            fontSizeMobile: 20,
                            fontWeight: '600',
                            textAlign: 'center',
                            marginBottom: 8
                        },
                        {
                            type: 'text',
                            elementType: 'p',
                            content: 'Perfect for individuals and small projects getting started',
                            fontSize: 14,
                            fontSizeMobile: 13,
                            fontWeight: '400',
                            textAlign: 'center',
                            color: '#666666',
                            marginBottom: 20
                        },
                        {
                            type: 'text',
                            elementType: 'h1',
                            content: '$9',
                            fontSize: 48,
                            fontSizeMobile: 40,
                            fontWeight: '700',
                            textAlign: 'center',
                            color: '#667eea',
                            marginBottom: 4
                        },
                        {
                            type: 'text',
                            elementType: 'p',
                            content: 'per month',
                            fontSize: 14,
                            fontSizeMobile: 13,
                            fontWeight: '400',
                            textAlign: 'center',
                            color: '#888888',
                            marginBottom: 24
                        },
                        {
                            type: 'grid',
                            columns: 1,
                            gap: 10,
                            gapMobile: 8,
                            columnTemplate: 'equal',
                            marginTop: 0,
                            marginBottom: 24,
                            gridDirection: 'horizontal',
                            cellDefaultBackground: 'transparent',
                            cellDefaultPadding: 0,
                            cellDefaultBorderRadius: 0,
                            cellDefaultBorderEnabled: false,
                            cellDefaultBoxShadow: 'none',
                            cellDefaultFlexDirection: 'row',
                            cellDefaultAlignItems: 'center',
                            cellDefaultJustifyContent: 'flex-start',
                            cellDefaultGap: 12,
                            children: [
                                {
                                    type: 'cell',
                                    cellIndex: 0,
                                    children: [
                                        {
                                            type: 'image',
                                            imageUrl: '/img/done.svg',
                                            width: 16,
                                            widthType: 'pixel',
                                            height: 16,
                                            heightType: 'pixel',
                                            objectFit: 'contain',
                                            alignment: 'left',
                                            marginRight: 0,
                                            marginLeft: 0,
                                            marginTop: 0,
                                            marginBottom: 0
                                        },
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: 'Up to 5 users',
                                            fontSize: 14,
                                            fontSizeMobile: 13,
                                            fontWeight: '400',
                                            textAlign: 'left',
                                            color: '#666666',
                                            marginTop: 0,
                                            marginBottom: 0
                                        }
                                    ]
                                },
                                {
                                    type: 'cell',
                                    cellIndex: 1,
                                    children: [
                                        {
                                            type: 'image',
                                            imageUrl: '/img/done.svg',
                                            width: 16,
                                            widthType: 'pixel',
                                            height: 16,
                                            heightType: 'pixel',
                                            objectFit: 'contain',
                                            alignment: 'left',
                                            marginRight: 0,
                                            marginLeft: 0,
                                            marginTop: 0,
                                            marginBottom: 0
                                        },
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: '10 GB storage',
                                            fontSize: 14,
                                            fontSizeMobile: 13,
                                            fontWeight: '400',
                                            textAlign: 'left',
                                            color: '#666666',
                                            marginTop: 0,
                                            marginBottom: 0
                                        }
                                    ]
                                },
                                {
                                    type: 'cell',
                                    cellIndex: 2,
                                    children: [
                                        {
                                            type: 'image',
                                            imageUrl: '/img/done.svg',
                                            width: 16,
                                            widthType: 'pixel',
                                            height: 16,
                                            heightType: 'pixel',
                                            objectFit: 'contain',
                                            alignment: 'left',
                                            marginRight: 0,
                                            marginLeft: 0,
                                            marginTop: 0,
                                            marginBottom: 0
                                        },
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: 'Email support',
                                            fontSize: 14,
                                            fontSizeMobile: 13,
                                            fontWeight: '400',
                                            textAlign: 'left',
                                            color: '#666666',
                                            marginTop: 0,
                                            marginBottom: 0
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'button',
                            buttonText: 'Get Started',
                            buttonTextSize: 16,
                            buttonTextSizeMobile: 15,
                            buttonWidth: 200, // ✅ Desktop: 200px
                            buttonWidthMobile: 100, // ✅ Mobile: 100% (Prozent-Wert)
                            buttonMaxWidth: 300,
                            buttonMaxWidthMobile: 280,
                            buttonHeight: 48,
                            buttonHeightMobile: 46,
                            buttonColor: '#667eea',  // ✅ Fallback - wird durch Brand Colors überschrieben
                            buttonTextColor: '#ffffff',
                            buttonBorderRadius: 8,
                            buttonBorderRadiusMobile: 8,
                            buttonAlignment: 'center',
                            buttonAlignmentMobile: 'center',
                            marginBottom: 0
                        }
                    ]
                },
                {
                    type: 'cell',
                    cellIndex: 1,
                    backgroundColor: '#f8f9ff',  // ✅ Fallback - wird durch Brand Colors überschrieben
                    children: [
                        {
                            type: 'text',
                            elementType: 'h3',
                            content: 'Pro',
                            fontSize: 24,
                            fontSizeMobile: 20,
                            fontWeight: '600',
                            textAlign: 'center',
                            color: '#1a1a1a',  // ✅ Wird durch Brand Colors überschrieben
                            marginBottom: 8
                        },
                        {
                            type: 'text',
                            elementType: 'p',
                            content: 'Best for growing teams and professional projects',
                            fontSize: 14,
                            fontSizeMobile: 13,
                            fontWeight: '400',
                            textAlign: 'center',
                            color: '#888888',  // ✅ Wird durch Brand Colors überschrieben
                            marginBottom: 20
                        },
                        {
                            type: 'text',
                            elementType: 'h1',
                            content: '$29',
                            fontSize: 48,
                            fontSizeMobile: 40,
                            fontWeight: '700',
                            textAlign: 'center',
                            color: '#667eea',  // ✅ Wird durch Brand Colors überschrieben
                            marginBottom: 4
                        },
                        {
                            type: 'text',
                            elementType: 'p',
                            content: 'per month',
                            fontSize: 14,
                            fontSizeMobile: 13,
                            fontWeight: '400',
                            textAlign: 'center',
                            color: '#888888',  // ✅ Wird durch Brand Colors überschrieben
                            marginBottom: 24
                        },
                        {
                            type: 'grid',
                            columns: 1,
                            gap: 10,
                            gapMobile: 8,
                            columnTemplate: 'equal',
                            marginTop: 0,
                            marginBottom: 24,
                            gridDirection: 'horizontal',
                            cellDefaultBackground: 'transparent',
                            cellDefaultPadding: 0,
                            cellDefaultBorderRadius: 0,
                            cellDefaultBorderEnabled: false,
                            cellDefaultBoxShadow: 'none',
                            cellDefaultFlexDirection: 'row',
                            cellDefaultAlignItems: 'center',
                            cellDefaultJustifyContent: 'flex-start',
                            cellDefaultGap: 12,
                            children: [
                                {
                                    type: 'cell',
                                    cellIndex: 0,
                                    children: [
                                        {
                                            type: 'image',
                                            imageUrl: '/img/done.svg',
                                            width: 16,
                                            widthType: 'pixel',
                                            height: 16,
                                            heightType: 'pixel',
                                            objectFit: 'contain',
                                            alignment: 'left',
                                            marginRight: 0,
                                            marginLeft: 0,
                                            marginTop: 0,
                                            marginBottom: 0
                                        },
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: 'Unlimited users',
                                            fontSize: 14,
                                            fontSizeMobile: 13,
                                            fontWeight: '400',
                                            textAlign: 'left',
                                            color: '#666666',  // ✅ Fallback
                                            marginTop: 0,
                                            marginBottom: 0
                                        }
                                    ]
                                },
                                {
                                    type: 'cell',
                                    cellIndex: 1,
                                    children: [
                                        {
                                            type: 'image',
                                            imageUrl: '/img/done.svg',
                                            width: 16,
                                            widthType: 'pixel',
                                            height: 16,
                                            heightType: 'pixel',
                                            objectFit: 'contain',
                                            alignment: 'left',
                                            marginRight: 0,
                                            marginLeft: 0,
                                            marginTop: 0,
                                            marginBottom: 0
                                        },
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: '100 GB storage',
                                            fontSize: 14,
                                            fontSizeMobile: 13,
                                            fontWeight: '400',
                                            textAlign: 'left',
                                            color: '#666666',  // ✅ Fallback
                                            marginTop: 0,
                                            marginBottom: 0
                                        }
                                    ]
                                },
                                {
                                    type: 'cell',
                                    cellIndex: 2,
                                    children: [
                                        {
                                            type: 'image',
                                            imageUrl: '/img/done.svg',
                                            width: 16,
                                            widthType: 'pixel',
                                            height: 16,
                                            heightType: 'pixel',
                                            objectFit: 'contain',
                                            alignment: 'left',
                                            marginRight: 0,
                                            marginLeft: 0,
                                            marginTop: 0,
                                            marginBottom: 0
                                        },
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: 'Priority support',
                                            fontSize: 14,
                                            fontSizeMobile: 13,
                                            fontWeight: '400',
                                            textAlign: 'left',
                                            color: '#666666',  // ✅ Fallback
                                            marginTop: 0,
                                            marginBottom: 0
                                        }
                                    ]
                                },
                                {
                                    type: 'cell',
                                    cellIndex: 3,
                                    children: [
                                        {
                                            type: 'image',
                                            imageUrl: '/img/done.svg',
                                            width: 16,
                                            widthType: 'pixel',
                                            height: 16,
                                            heightType: 'pixel',
                                            objectFit: 'contain',
                                            alignment: 'left',
                                            marginRight: 0,
                                            marginLeft: 0,
                                            marginTop: 0,
                                            marginBottom: 0
                                        },
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: 'Advanced analytics',
                                            fontSize: 14,
                                            fontSizeMobile: 13,
                                            fontWeight: '400',
                                            textAlign: 'left',
                                            color: '#666666',  // ✅ Fallback
                                            marginTop: 0,
                                            marginBottom: 0
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'button',
                            buttonText: 'Get Started',
                            buttonTextSize: 16,
                            buttonTextSizeMobile: 15,
                            buttonWidth: 200, // ✅ Desktop: 200px
                            buttonWidthMobile: 100, // ✅ Mobile: 100% (Prozent-Wert)
                            buttonMaxWidth: 300,
                            buttonMaxWidthMobile: 280,
                            buttonHeight: 48,
                            buttonHeightMobile: 46,
                            buttonColor: '#667eea',  // ✅ Fallback - wird durch Brand Colors überschrieben
                            buttonTextColor: '#ffffff',
                            buttonBorderRadius: 8,
                            buttonBorderRadiusMobile: 8,
                            buttonAlignment: 'center',
                            buttonAlignmentMobile: 'center',
                            marginBottom: 0
                        }
                    ]
                },
                {
                    type: 'cell',
                    cellIndex: 2,
                    children: [
                        {
                            type: 'text',
                            elementType: 'h3',
                            content: 'Enterprise',
                            fontSize: 24,
                            fontSizeMobile: 20,
                            fontWeight: '600',
                            textAlign: 'center',
                            marginBottom: 8
                        },
                        {
                            type: 'text',
                            elementType: 'p',
                            content: 'Advanced features for large organizations and teams',
                            fontSize: 14,
                            fontSizeMobile: 13,
                            fontWeight: '400',
                            textAlign: 'center',
                            color: '#666666',
                            marginBottom: 20
                        },
                        {
                            type: 'text',
                            elementType: 'h1',
                            content: '$99',
                            fontSize: 48,
                            fontSizeMobile: 40,
                            fontWeight: '700',
                            textAlign: 'center',
                            color: '#667eea',
                            marginBottom: 4
                        },
                        {
                            type: 'text',
                            elementType: 'p',
                            content: 'per month',
                            fontSize: 14,
                            fontSizeMobile: 13,
                            fontWeight: '400',
                            textAlign: 'center',
                            color: '#888888',
                            marginBottom: 24
                        },
                        {
                            type: 'grid',
                            columns: 1,
                            gap: 10,
                            gapMobile: 8,
                            columnTemplate: 'equal',
                            marginTop: 0,
                            marginBottom: 24,
                            gridDirection: 'horizontal',
                            cellDefaultBackground: 'transparent',
                            cellDefaultPadding: 0,
                            cellDefaultBorderRadius: 0,
                            cellDefaultBorderEnabled: false,
                            cellDefaultBoxShadow: 'none',
                            cellDefaultFlexDirection: 'row',
                            cellDefaultAlignItems: 'center',
                            cellDefaultJustifyContent: 'flex-start',
                            cellDefaultGap: 12,
                            children: [
                                {
                                    type: 'cell',
                                    cellIndex: 0,
                                    children: [
                                        {
                                            type: 'image',
                                            imageUrl: '/img/done.svg',
                                            width: 16,
                                            widthType: 'pixel',
                                            height: 16,
                                            heightType: 'pixel',
                                            objectFit: 'contain',
                                            alignment: 'left',
                                            marginRight: 0,
                                            marginLeft: 0,
                                            marginTop: 0,
                                            marginBottom: 0
                                        },
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: 'Unlimited everything',
                                            fontSize: 14,
                                            fontSizeMobile: 13,
                                            fontWeight: '400',
                                            textAlign: 'left',
                                            color: '#666666',
                                            marginTop: 0,
                                            marginBottom: 0
                                        }
                                    ]
                                },
                                {
                                    type: 'cell',
                                    cellIndex: 1,
                                    children: [
                                        {
                                            type: 'image',
                                            imageUrl: '/img/done.svg',
                                            width: 16,
                                            widthType: 'pixel',
                                            height: 16,
                                            heightType: 'pixel',
                                            objectFit: 'contain',
                                            alignment: 'left',
                                            marginRight: 0,
                                            marginLeft: 0,
                                            marginTop: 0,
                                            marginBottom: 0
                                        },
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: 'Dedicated account manager',
                                            fontSize: 14,
                                            fontSizeMobile: 13,
                                            fontWeight: '400',
                                            textAlign: 'left',
                                            color: '#666666',
                                            marginTop: 0,
                                            marginBottom: 0
                                        }
                                    ]
                                },
                                {
                                    type: 'cell',
                                    cellIndex: 2,
                                    children: [
                                        {
                                            type: 'image',
                                            imageUrl: '/img/done.svg',
                                            width: 16,
                                            widthType: 'pixel',
                                            height: 16,
                                            heightType: 'pixel',
                                            objectFit: 'contain',
                                            alignment: 'left',
                                            marginRight: 0,
                                            marginLeft: 0,
                                            marginTop: 0,
                                            marginBottom: 0
                                        },
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: 'Custom integrations',
                                            fontSize: 14,
                                            fontSizeMobile: 13,
                                            fontWeight: '400',
                                            textAlign: 'left',
                                            color: '#666666',
                                            marginTop: 0,
                                            marginBottom: 0
                                        }
                                    ]
                                },
                                {
                                    type: 'cell',
                                    cellIndex: 3,
                                    children: [
                                        {
                                            type: 'image',
                                            imageUrl: '/img/done.svg',
                                            width: 16,
                                            widthType: 'pixel',
                                            height: 16,
                                            heightType: 'pixel',
                                            objectFit: 'contain',
                                            alignment: 'left',
                                            marginRight: 0,
                                            marginLeft: 0,
                                            marginTop: 0,
                                            marginBottom: 0
                                        },
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: 'SLA guarantee',
                                            fontSize: 14,
                                            fontSizeMobile: 13,
                                            fontWeight: '400',
                                            textAlign: 'left',
                                            color: '#666666',
                                            marginTop: 0,
                                            marginBottom: 0
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'button',
                            buttonText: 'Contact Sales',
                            buttonTextSize: 16,
                            buttonTextSizeMobile: 15,
                            buttonWidth: 200, // ✅ Desktop: 200px
                            buttonWidthMobile: 100, // ✅ Mobile: 100% (Prozent-Wert)
                            buttonMaxWidth: 300,
                            buttonMaxWidthMobile: 280,
                            buttonHeight: 48,
                            buttonHeightMobile: 46,
                            buttonColor: '#667eea',  // ✅ Fallback - wird durch Brand Colors überschrieben
                            buttonTextColor: '#ffffff',
                            buttonBorderRadius: 8,
                            buttonBorderRadiusMobile: 8,
                            buttonAlignment: 'center',
                            buttonAlignmentMobile: 'center',
                            marginBottom: 0
                        }
                    ]
                }
            ]
        }
    },
    
    // 🏢 FOOTER (3 Columns) - Company Info, Contact, Social Media
    'footer-3-column': {
        name: 'Footer (3 Columns)',
        description: 'Professional footer with company info, contact details, and social links',
        icon: 'fa-building',
        category: 'footer',
        grid: {
            columns: 3,
            gap: 40,
            gapMobile: 30,
            columnTemplate: 'equal',
            marginTop: 60,
            marginBottom: 0,
            maxWidth: 1400,  // ✅ Max Width für Footer (breiter)
            maxWidthMobile: 1000,  // ✅ Mobile Max Width
            gridDirection: 'horizontal',
            gridDirectionMobile: 'vertical', // ✅ Mobile: Stack vertical
            cellDefaultBackground: 'transparent',
            cellDefaultPadding: 20,
            cellDefaultPaddingMobile: 20,
            cellDefaultBorderRadius: 0,
            cellDefaultBorderEnabled: false,
            cellDefaultBoxShadow: 'none',
            boxShadow: 'none',
            cellDefaultFlexDirection: 'column',
            cellDefaultAlignItems: 'flex-start',
            cellDefaultJustifyContent: 'flex-start',
            cellDefaultGap: 16,
            cellDefaultGapMobile: 12,
            children: [
                // ✅ CELL 1: Company Info (Logo + Name + Tagline)
                {
                    type: 'cell',
                    cellIndex: 0,
                    children: [
                        // Logo Icon
                        {
                            type: 'image',
                            imageUrl: '/img/your-logo.webp',
                            width: 48,
                            widthType: 'pixel',
                            height: 48,
                            heightType: 'pixel',
                            objectFit: 'contain',
                            alignment: 'left',
                            borderRadius: 8,
                            containerBgColor: 'transparent',
                            iconContainerSize: 48,
                            iconContainerSizeMobile: 42,
                            padding: 0,
                            paddingMobile: 0,
                            borderEnabled: false,
                            shadowEnabled: false,
                            marginBottom: 12,
                            marginTop: 0
                        },
                        // Company Name
                        {
                            type: 'text',
                            elementType: 'h2',
                            content: 'Your Company',
                            fontSize: 24,
                            fontSizeMobile: 22,
                            fontWeight: '700',
                            textAlign: 'left',
                            color: '#1a1a1a',
                            marginBottom: 8,
                            marginTop: 0
                        },
                        // Tagline
                        {
                            type: 'text',
                            elementType: 'p',
                            content: 'Your inspiring slogan here',
                            fontSize: 14,
                            fontSizeMobile: 13,
                            fontWeight: '400',
                            textAlign: 'left',
                            color: '#999999',
                            lineHeight: 1.5,
                            marginBottom: 0,
                            marginTop: 0
                        }
                    ]
                },
                // ✅ CELL 2: Contact Info
                {
                    type: 'cell',
                    cellIndex: 1,
                    children: [
                        // Contact Heading
                        {
                            type: 'text',
                            elementType: 'h3',
                            content: 'Contact',
                            fontSize: 20,
                            fontSizeMobile: 18,
                            fontWeight: '700',
                            textAlign: 'left',
                            color: '#1a1a1a',
                            marginBottom: 16,
                            marginTop: 0
                        },
                        // Address (Icon + Text in horizontal grid)
                        {
                            type: 'grid',
                            columns: 1,
                            gap: 12,
                            gapMobile: 12,
                            columnTemplate: 'equal',
                            marginTop: 0,
                            marginBottom: 0,
                            gridDirection: 'horizontal',
                            gridDirectionMobile: 'horizontal',
                            cellDefaultBackground: 'transparent',
                            cellDefaultPadding: 0,
                            cellDefaultBorderRadius: 0,
                            cellDefaultBorderEnabled: false,
                            cellDefaultFlexDirection: 'row',
                            cellDefaultAlignItems: 'flex-start',
                            cellDefaultJustifyContent: 'flex-start',
                            cellDefaultGap: 10,
                            cellDefaultGapMobile: 10,
                            children: [
                                // Address Row
                                {
                                    type: 'cell',
                                    cellIndex: 0,
                                    children: [
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: '📍',
                                            fontSize: 16,
                                            fontSizeMobile: 16,
                                            fontWeight: '400',
                                            textAlign: 'left',
                                            color: '#666666',
                                            marginBottom: 0,
                                            marginTop: 0,
                                            marginRight: 0
                                        },
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: '123 Business Street Your City, State 12345',
                                            fontSize: 14,
                                            fontSizeMobile: 13,
                                            fontWeight: '400',
                                            textAlign: 'left',
                                            color: '#666666',
                                            lineHeight: 1.5,
                                            marginBottom: 0,
                                            marginTop: 0
                                        }
                                    ]
                                },
                                // Phone Row
                                {
                                    type: 'cell',
                                    cellIndex: 1,
                                    children: [
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: '📞',
                                            fontSize: 16,
                                            fontSizeMobile: 16,
                                            fontWeight: '400',
                                            textAlign: 'left',
                                            color: '#666666',
                                            marginBottom: 0,
                                            marginTop: 0
                                        },
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: '+1 (555) 123-4567',
                                            fontSize: 14,
                                            fontSizeMobile: 13,
                                            fontWeight: '400',
                                            textAlign: 'left',
                                            color: '#666666',
                                            marginBottom: 0,
                                            marginTop: 0
                                        }
                                    ]
                                },
                                // Email Row
                                {
                                    type: 'cell',
                                    cellIndex: 2,
                                    children: [
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: '✉️',
                                            fontSize: 16,
                                            fontSizeMobile: 16,
                                            fontWeight: '400',
                                            textAlign: 'left',
                                            color: '#666666',
                                            marginBottom: 0,
                                            marginTop: 0
                                        },
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: 'contact@yourcompany.com',
                                            fontSize: 14,
                                            fontSizeMobile: 13,
                                            fontWeight: '400',
                                            textAlign: 'left',
                                            color: '#666666',
                                            marginBottom: 0,
                                            marginTop: 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                // ✅ CELL 3: Social Media (Follow Us)
                {
                    type: 'cell',
                    cellIndex: 2,
                    children: [
                        // Follow Us Heading
                        {
                            type: 'text',
                            elementType: 'h3',
                            content: 'Follow Us',
                            fontSize: 20,
                            fontSizeMobile: 18,
                            fontWeight: '700',
                            textAlign: 'left',
                            color: '#1a1a1a',
                            marginBottom: 16,
                            marginTop: 0
                        },
                        // Social Media Icons Grid
                        {
                            type: 'grid',
                            columns: 4,
                            gap: 12,
                            gapMobile: 10,
                            columnTemplate: 'equal',
                            marginTop: 0,
                            marginBottom: 0,
                            gridDirection: 'horizontal',
                            gridDirectionMobile: 'horizontal',
                            cellDefaultBackground: 'transparent',
                            cellDefaultPadding: 12,
                            cellDefaultPaddingMobile: 10,
                            cellDefaultBorderRadius: 50,
                            cellDefaultBorderEnabled: true,
                            cellDefaultBorderWidth: 2,
                            cellDefaultBorderColor: '#1a1a1a',
                            cellDefaultHeight: 48, // ✅ Fixed height für quadratische Icons
                            cellDefaultHeightMobile: 42,
                            cellDefaultFlexDirection: 'row',
                            cellDefaultAlignItems: 'center',
                            cellDefaultJustifyContent: 'center',
                            cellDefaultGap: 0,
                            children: [
                                // Facebook
                                {
                                    type: 'cell',
                                    cellIndex: 0,
                                    children: [
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: 'f',
                                            fontSize: 20,
                                            fontSizeMobile: 18,
                                            fontWeight: '600',
                                            fontFamily: 'Georgia',
                                            textAlign: 'center',
                                            color: '#1a1a1a',
                                            marginBottom: 0,
                                            marginTop: 0
                                        }
                                    ]
                                },
                                // Instagram
                                {
                                    type: 'cell',
                                    cellIndex: 1,
                                    children: [
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: '📷',
                                            fontSize: 20,
                                            fontSizeMobile: 18,
                                            fontWeight: '400',
                                            textAlign: 'center',
                                            color: '#1a1a1a',
                                            marginBottom: 0,
                                            marginTop: 0
                                        }
                                    ]
                                },
                                // LinkedIn
                                {
                                    type: 'cell',
                                    cellIndex: 2,
                                    children: [
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: 'in',
                                            fontSize: 18,
                                            fontSizeMobile: 16,
                                            fontWeight: '700',
                                            fontFamily: 'Arial',
                                            textAlign: 'center',
                                            color: '#1a1a1a',
                                            marginBottom: 0,
                                            marginTop: 0
                                        }
                                    ]
                                },
                                // YouTube
                                {
                                    type: 'cell',
                                    cellIndex: 3,
                                    children: [
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: '▶',
                                            fontSize: 16,
                                            fontSizeMobile: 14,
                                            fontWeight: '700',
                                            textAlign: 'center',
                                            color: '#1a1a1a',
                                            marginBottom: 0,
                                            marginTop: 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    
    // 🎨 FOOTER MINIMAL (3 Columns) - Copyright | Logo Center | Social Icons
    'footer-minimal': {
        name: 'Footer Minimal',
        description: 'Minimalist footer with centered logo',
        icon: 'fa-minus',
        category: 'footer',
        grid: {
            columns: 3,
            gap: 20,
            gapMobile: 15,
            columnTemplate: 'equal',
            marginTop: 40,
            marginBottom: 0,
            maxWidth: 900,  // ✅ Max Width für minimalen Footer
            maxWidthMobile: 700,  // ✅ Mobile Max Width
            gridDirection: 'horizontal',
            gridDirectionMobile: 'vertical', // ✅ Mobile: Stack vertical
            cellDefaultBackground: 'transparent',
            cellDefaultPadding: 12,
            cellDefaultPaddingMobile: 10,
            cellDefaultBorderRadius: 0,
            cellDefaultBorderEnabled: false,
            cellDefaultBoxShadow: 'none',
            boxShadow: 'none',
            cellDefaultFlexDirection: 'column',
            cellDefaultAlignItems: 'center', // ✅ Alles zentriert
            cellDefaultJustifyContent: 'center',
            cellDefaultGap: 8,
            cellDefaultGapMobile: 8,
            children: [
                // ✅ CELL 1: Company Name (Links)
                {
                    type: 'cell',
                    cellIndex: 0,
                    children: [
                        {
                            type: 'text',
                            elementType: 'p',
                            content: 'Your Company',
                            fontSize: 14,
                            fontSizeMobile: 13,
                            fontWeight: '600',
                            textAlign: 'center',
                            color: '#333333',
                            lineHeight: 1.4,
                            marginBottom: 0,
                            marginTop: 0
                        }
                    ]
                },
                // ✅ CELL 2: Logo zentriert (Mitte)
                {
                    type: 'cell',
                    cellIndex: 1,
                    children: [
                        {
                            type: 'image',
                            imageUrl: '/img/your-logo.webp',
                            width: 40,
                            widthType: 'pixel',
                            height: 40,
                            heightType: 'pixel',
                            objectFit: 'contain',
                            alignment: 'center',
                            borderRadius: 8,
                            containerBgColor: 'transparent',
                            iconContainerSize: 40,
                            iconContainerSizeMobile: 36,
                            padding: 0,
                            paddingMobile: 0,
                            borderEnabled: false,
                            shadowEnabled: false,
                            marginBottom: 0,
                            marginTop: 0
                        }
                    ]
                },
                // ✅ CELL 3: Legal Links (Rechts - Imprint & Terms nebeneinander)
                {
                    type: 'cell',
                    cellIndex: 2,
                    children: [
                        // Legal Links Grid - Horizontal
                        {
                            type: 'grid',
                            columns: 2,
                            gap: 16,
                            gapMobile: 12,
                            columnTemplate: 'equal',
                            marginTop: 0,
                            marginBottom: 0,
                            gridDirection: 'horizontal',
                            gridDirectionMobile: 'horizontal',
                            cellDefaultBackground: 'transparent',
                            cellDefaultPadding: 0,
                            cellDefaultBorderRadius: 0,
                            cellDefaultBorderEnabled: false,
                            cellDefaultFlexDirection: 'column',
                            cellDefaultAlignItems: 'center',
                            cellDefaultJustifyContent: 'center',
                            cellDefaultGap: 0,
                            children: [
                                // Imprint
                                {
                                    type: 'cell',
                                    cellIndex: 0,
                                    children: [
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: 'Imprint',
                                            fontSize: 13,
                                            fontSizeMobile: 12,
                                            fontWeight: '400',
                                            textAlign: 'center',
                                            color: '#666666',
                                            lineHeight: 1.4,
                                            marginBottom: 0,
                                            marginTop: 0
                                        }
                                    ]
                                },
                                // Terms of Use
                                {
                                    type: 'cell',
                                    cellIndex: 1,
                                    children: [
                                        {
                                            type: 'text',
                                            elementType: 'p',
                                            content: 'Terms of Use',
                                            fontSize: 13,
                                            fontSizeMobile: 12,
                                            fontWeight: '400',
                                            textAlign: 'center',
                                            color: '#666666',
                                            lineHeight: 1.4,
                                            marginBottom: 0,
                                            marginTop: 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },

    // 🎯 SEAMLESS GRID (4 Values - Full Width with Divider Lines)
    'seamless-grid-4': {
        name: 'Seamless Grid (4 Values)',
        description: 'Full-width grid with subtle divider lines between cells',
        icon: 'fa-border-all',
        category: 'features',
        grid: {
            columns: 4,
            gap: 0,  // ✅ NO GAP - Seamless!
            gapMobile: 0,
            columnTemplate: 'equal',
            marginTop: 0,
            marginBottom: 0,
            maxWidth: 1600,  // ✅ Breiter für Seamless Grid (kann Full-Width sein)
            maxWidthMobile: 1200,  // ✅ Mobile Max Width
            gridDirection: 'horizontal',
            gridDirectionMobile: 'vertical', // Mobile: Stack vertical
            // ✅ SEAMLESS MODE SETTINGS
            seamlessMode: true,  // ✅ Aktiviert Seamless Border-Logik
            seamlessBorderWidth: 1,
            seamlessBorderColor: '#e0e0e0',
            seamlessBorderStyle: 'solid',
            // Grid Container selbst
            backgroundColor: 'transparent',
            borderEnabled: true,  // ✅ Äußerer Border
            borderWidth: 1,
            borderColor: '#e0e0e0',
            borderRadius: 0,  // ✅ Keine runden Ecken
            // Cell Defaults
            cellDefaultBackground: 'transparent',
            cellDefaultPadding: 32,
            cellDefaultPaddingMobile: 24,
            cellDefaultBorderRadius: 0,  // ✅ Keine runden Ecken
            cellDefaultBorderEnabled: false,  // ✅ Border wird via Seamless Mode gehandhabt
            cellDefaultFlexDirection: 'column',
            cellDefaultAlignItems: 'center',
            cellDefaultJustifyContent: 'center',
            children: [
                {
                    type: 'cell',
                    cellIndex: 0,
                    children: [
                        {
                            type: 'text',
                            elementType: 'h3',
                            content: '250+',
                            fontSize: 48,
                            fontSizeMobile: 36,
                            fontWeight: '700',
                            textAlign: 'center',
                            color: '#1a1a1a',
                            marginBottom: 8
                        },
                        {
                            type: 'text',
                            elementType: 'p',
                            content: 'Happy Clients',
                            fontSize: 16,
                            fontSizeMobile: 14,
                            fontWeight: '400',
                            textAlign: 'center',
                            color: '#666666',
                            lineHeight: 1.5
                        }
                    ]
                },
                {
                    type: 'cell',
                    cellIndex: 1,
                    children: [
                        {
                            type: 'text',
                            elementType: 'h3',
                            content: '15+',
                            fontSize: 48,
                            fontSizeMobile: 36,
                            fontWeight: '700',
                            textAlign: 'center',
                            color: '#1a1a1a',
                            marginBottom: 8
                        },
                        {
                            type: 'text',
                            elementType: 'p',
                            content: 'Years Experience',
                            fontSize: 16,
                            fontSizeMobile: 14,
                            fontWeight: '400',
                            textAlign: 'center',
                            color: '#666666',
                            lineHeight: 1.5
                        }
                    ]
                },
                {
                    type: 'cell',
                    cellIndex: 2,
                    children: [
                        {
                            type: 'text',
                            elementType: 'h3',
                            content: '98%',
                            fontSize: 48,
                            fontSizeMobile: 36,
                            fontWeight: '700',
                            textAlign: 'center',
                            color: '#1a1a1a',
                            marginBottom: 8
                        },
                        {
                            type: 'text',
                            elementType: 'p',
                            content: 'Satisfaction Rate',
                            fontSize: 16,
                            fontSizeMobile: 14,
                            fontWeight: '400',
                            textAlign: 'center',
                            color: '#666666',
                            lineHeight: 1.5
                        }
                    ]
                },
                {
                    type: 'cell',
                    cellIndex: 3,
                    children: [
                        {
                            type: 'text',
                            elementType: 'h3',
                            content: '24/7',
                            fontSize: 48,
                            fontSizeMobile: 36,
                            fontWeight: '700',
                            textAlign: 'center',
                            color: '#1a1a1a',
                            marginBottom: 8
                        },
                        {
                            type: 'text',
                            elementType: 'p',
                            content: 'Support Available',
                            fontSize: 16,
                            fontSizeMobile: 14,
                            fontWeight: '400',
                            textAlign: 'center',
                            color: '#666666',
                            lineHeight: 1.5
                        }
                    ]
                }
            ]
        }
    }
};

/**
 * Get grid preset by ID
 */
export const getGridPreset = (presetId) => {
    return gridPresets[presetId] || null;
};

/**
 * Get all presets for a category
 */
export const getPresetsByCategory = (category) => {
    return Object.entries(gridPresets)
        .filter(([_, preset]) => preset.category === category)
        .map(([id, preset]) => ({ id, ...preset }));
};

/**
 * Get all categories
 */
export const getPresetCategories = () => {
    const categories = new Set();
    Object.values(gridPresets).forEach(preset => {
        categories.add(preset.category);
    });
    return Array.from(categories);
};

/**
 * Helper: Calculate luminance of a color
 */
const getLuminance = (color) => {
    if (!color) return 0.5;
    
    // Remove # if present
    const hex = color.replace('#', '');
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    
    // Calculate relative luminance
    const a = [r, g, b].map(v => {
        v = v / 255;
        return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
};

/**
 * Helper: Check if color is dark
 */
const isDarkColor = (color) => {
    return getLuminance(color) < 0.5;
};

/**
 * Helper: Get contrast ratio between two colors
 */
const getContrastRatio = (color1, color2) => {
    const l1 = getLuminance(color1);
    const l2 = getLuminance(color2);
    const lighter = Math.max(l1, l2);
    const darker = Math.min(l1, l2);
    return (lighter + 0.05) / (darker + 0.05);
};

/**
 * Helper: Sort colors by luminance for intelligent assignment
 */
const sortColorsByLuminance = (colors) => {
    return colors
        .map(color => ({ color, luminance: getLuminance(color) }))
        .sort((a, b) => a.luminance - b.luminance); // Dunkelste zuerst
};

/**
 * Apply preset to create grid element
 * Adds unique IDs and order to all elements
 * @param {string} presetId - ID des Presets
 * @param {number} order - Order des Grid Elements
 * @param {object} colors - Brand Colors für dynamische Farben
 */
export const applyGridPreset = (presetId, order = 0, colors = {}, fonts = {}, colorAssignments = {}) => {
    const preset = getGridPreset(presetId);
    if (!preset) return null;
    
    const timestamp = Date.now();
    
    // ✅ Brand Colors Array für intelligente Verteilung
    const brandColors = Object.values(colors);
    
    // ✅ NEW: Brand Fonts für Text-Elemente
    const brandFonts = {
        globalBigFont: fonts.globalBigFont || '',
        globalSmallFont: fonts.globalSmallFont || ''
    };
    
    // ✅ NEW: Color Assignments für Text-Farben (wie in HeroHeader/DynamicContainerSection)
    const defaultColorAssignments = {
        primaryText: 'color2',
        secondaryText: 'color3',
        buttons: 'color1',
        buttonText: 'color5',
        ...colorAssignments
    };
    
    // ✅ Sort colors by luminance (dunkelste zuerst)
    const sortedColors = sortColorsByLuminance(brandColors);
    
    // ✅ INTELLIGENTE FARB-VERTEILUNG für Premium Presets - UMGEKEHRT!
    let lightestColor = '#f8f9ff'; // Default heller Background
    let iconColor = '#1a202c'; // Default dunkler Icon
    let darkestColor = '#1a202c'; // Default dunkelste Farbe (für Pricing Highlight)
    
    if (brandColors.length > 0 && (presetId === 'premium-checklist' || presetId === 'premium-checklist-straight' || presetId === 'feature-list' ||
        presetId === 'product-features-4' || presetId === 'pricing-3' || presetId === 'image-text-2col')) {
        // ✅ HELLSTE Farbe für Background (elegant & clean)
        lightestColor = sortedColors[sortedColors.length - 1]?.color || '#f8f9ff';
        
        // ✅ DUNKELSTE Farbe für alle Icons (einheitlich & elegant) UND für Pricing Highlight
        darkestColor = sortedColors[0]?.color || '#1a202c';
        
        if (sortedColors.length > 1) {
            // Dunkelste Farbe (bester Kontrast zum hellen Background)
            iconColor = sortedColors[0].color;
            
            // ✅ KONTRAST-CHECK: Mindestens 3:1 für gute Lesbarkeit
            const contrast = getContrastRatio(iconColor, lightestColor);
            
            if (contrast < 3) {
                // Zu wenig Kontrast: Nutze zweitdunkelste oder Schwarz
                if (sortedColors.length > 2) {
                    iconColor = sortedColors[1].color;
                } else {
                    iconColor = '#1a202c'; // Fallback auf Dunkelgrau
                }
                console.log('⚠️ Icon color adjusted for better contrast:', iconColor);
            }
        } else if (sortedColors.length === 1) {
            // Nur eine Farbe: Nutze sie für Icons wenn hell genug, sonst dunkel
            iconColor = isDarkColor(sortedColors[0].color) ? sortedColors[0].color : '#1a202c';
        }
    }
    
    console.log('🎨 Color Distribution (Inverted):', {
        brandColors,
        lightestColor,
        iconColor,
        sortedColors: sortedColors.map(c => ({ color: c.color, luminance: c.luminance.toFixed(3) }))
    });
    
    // Deep clone and add IDs
    const addIdsRecursive = (obj, parentIndex = 0, parentCellIndex = null) => {
        if (Array.isArray(obj)) {
            return obj.map((item, idx) => addIdsRecursive(item, idx, parentCellIndex));
        }
        
        if (obj && typeof obj === 'object') {
            const newObj = { ...obj };
            
            // Add ID if type exists
            if (newObj.type) {
                newObj.id = `${newObj.type}-${timestamp}-${parentIndex}-${Math.random().toString(36).substr(2, 9)}`;
            }
            
            // Add order if not exists
            if (newObj.type && typeof newObj.order !== 'number') {
                newObj.order = parentIndex;
            }
            
            // ✅ Track cellIndex for nested content
            let currentCellIndex = parentCellIndex;
            if (newObj.type === 'cell' && newObj.cellIndex !== undefined) {
                currentCellIndex = newObj.cellIndex;
            }
            
            // ✅ DYNAMISCHE BRAND COLORS für Icons in Premium Presets
            if (newObj.type === 'image' && 
                newObj.iconContainerSize && 
                brandColors.length > 0 && 
                (presetId === 'premium-checklist' || presetId === 'premium-checklist-straight' || presetId === 'feature-list' || 
                 presetId === 'product-features-4')) {
                
                // ✅ ALLE ICONS = GLEICHE FARBE (cleaner, less overwhelming)
                newObj.containerBgColor = iconColor;
                
                // ✅ INVERT ICON wenn Container dunkel ist (für bessere Sichtbarkeit)
                // Icons wie done.svg sind oft dunkel, also auf dunklem Background invertieren
                if (isDarkColor(iconColor)) {
                    newObj.invertColors = true;
                    console.log('🔄 Icon inverted for dark background:', iconColor);
                } else {
                    newObj.invertColors = false;
                    console.log('🎨 Icon normal for light background:', iconColor);
                }
                
                console.log('🎨 Icon container color:', iconColor);
            }
            
            // ✅ PRICING TABLE FEATURE ICONS: Alle gleich (heller Background)
            if (newObj.type === 'image' && 
                !newObj.iconContainerSize &&  // ✅ KEINE Icon Container (nur kleine Checkmarks)
                presetId === 'pricing-3' &&
                currentCellIndex !== null) {
                
                // ✅ ALLE CARDS: Heller Background → Icons NICHT invertieren
                newObj.invertColors = false;
                console.log('🎨 Pricing feature icon normal for light background (all cards)');
            }
            
            // ✅ CELL BACKGROUND: Hellste Farbe für Premium Presets (UMGEKEHRT!)
            if (newObj.type === 'cell' && 
                brandColors.length > 0 && 
                (presetId === 'premium-checklist' || presetId === 'premium-checklist-straight' || presetId === 'feature-list' ||
                 presetId === 'product-features-4')) {
                
                // Überschreibe Cell Background mit hellster Farbe
                newObj.backgroundColor = lightestColor;
                
                // ✅ Intelligente Border Color & Shadow basierend auf Hintergrund
                // ABER: borderEnabled wird NICHT überschrieben - das kommt vom Preset!
                if (isDarkColor(lightestColor)) {
                    // Dunkler Background: Hellerer Border (nur Color, nicht enable!)
                    newObj.borderColor = 'rgba(255, 255, 255, 0.15)';
                } else {
                    // Heller Background: Dunkler Border (nur Color, nicht enable!)
                    newObj.borderColor = 'rgba(0, 0, 0, 0.08)';
                }
                
                // ✅ Border Enable/Width wird NICHT gesetzt - bleibt beim Preset Default!
                // Das ermöglicht es, Borders im Preset zu kontrollieren
                
                console.log('🎨 Cell background:', lightestColor, 'isDark:', isDarkColor(lightestColor));
            }
            
            // ✅ PRICING TABLE: Spezielle Logik für Pricing Cards
            if (newObj.type === 'cell' && 
                brandColors.length > 0 && 
                presetId === 'pricing-3') {
                
                // ✅ ALLE CARDS: Gleiche hellste Brand Color (clean & simple)
                newObj.backgroundColor = lightestColor;
                console.log('🎨 Pricing Card background (all same):', lightestColor);
                
                // ✅ Border Color basierend auf Background
                if (isDarkColor(lightestColor)) {
                    newObj.borderColor = 'rgba(255, 255, 255, 0.15)';
                } else {
                    newObj.borderColor = 'rgba(0, 0, 0, 0.08)';
                }
            }
            
            // ✅ NESTED GRIDS (Text-Container): Komplett clean - kein Shadow, kein Background
            // Gilt IMMER für diese Presets, unabhängig von Brand Colors
            if (newObj.type === 'grid' && 
                (presetId === 'premium-checklist' || presetId === 'premium-checklist-straight' || presetId === 'feature-list' ||
                 presetId === 'product-features-4' || presetId === 'pricing-3' || presetId === 'image-text-2col')) {
                
                // Detect nested grids (1-column grids sind immer Text-Container oder Feature-Listen)
                if (newObj.columns === 1 && parentIndex > 0) {
                    // Text-Container Grid: Überschreibe Defaults - KEIN Shadow!
                    newObj.cellDefaultBackground = 'transparent';
                    newObj.cellDefaultBoxShadow = 'none';
                    newObj.cellDefaultBorderEnabled = false;
                    newObj.cellDefaultPadding = 0;
                    newObj.cellDefaultBorderRadius = 0;
                    
                    console.log('🎨 Nested Grid (features/text): clean defaults, no shadow');
                }
            }
            
            // ✅ IMAGE-TEXT TEMPLATE: Intelligente Image Border basierend auf Brand Colors
            if (newObj.type === 'image' && 
                brandColors.length > 0 && 
                presetId === 'image-text-2col') {
                
                // ✅ Nutze hellste Brand Color für subtile Border (elegant!)
                const lightBorderColor = `${lightestColor}40`; // Mit 25% Opacity
                newObj.borderColor = lightBorderColor;
                
                console.log('🎨 Image border color set to light brand color:', lightBorderColor);
            }
            
            // ✅ TEXT COLOR & FONT: Für Premium Presets (OHNE image-text-2col)
            if (newObj.type === 'text' && 
                brandColors.length > 0 && 
                (presetId === 'premium-checklist' || presetId === 'premium-checklist-straight' || presetId === 'feature-list' ||
                 presetId === 'product-features-4')) {
                
                // ✅ UMGEKEHRT: Background ist jetzt hell, also Text dunkel
                if (isDarkColor(lightestColor)) {
                    // Dunkler Background (selten): Weißer Text
                    newObj.color = '#ffffff';
                    console.log('🎨 Text gets white color for dark background');
                } else {
                    // Heller Background (Standard): Dunkler Text
                    if (newObj.elementType === 'h3' || newObj.elementType === 'h2' || newObj.elementType === 'h1') {
                        // ✅ TITLE: Icon-Farbe für Konsistenz und Branding
                        newObj.color = iconColor;
                        console.log('🎨 Title gets icon color:', iconColor);
                    } else {
                        // ✅ DESCRIPTION: Etwas heller/grauer für Hierarchie
                        newObj.color = '#4a5568';
                        console.log('🎨 Description gets gray color');
                    }
                }
                
                // ✅ NEW: Apply Brand Font basierend auf elementType
                if (newObj.elementType === 'h1' && brandFonts.globalBigFont) {
                    newObj.fontFamily = brandFonts.globalBigFont;
                    console.log('🎨 H1 gets brand big font:', brandFonts.globalBigFont);
                } else if (brandFonts.globalSmallFont) {
                    newObj.fontFamily = brandFonts.globalSmallFont;
                    console.log('🎨 Text gets brand small font:', brandFonts.globalSmallFont);
                }
            }
            
            // ✅ IMAGE-TEXT TEMPLATE: Nutzt colorAssignments wie normale Elemente
            if (newObj.type === 'text' && 
                brandColors.length > 0 && 
                presetId === 'image-text-2col') {
                
                // ✅ GLEICHE LOGIK wie in HeroHeader/DynamicContainerSection
                if (newObj.elementType === 'h1' || newObj.elementType === 'h2' || newObj.elementType === 'h3') {
                    // Überschriften: Primary Text Color
                    const colorKey = defaultColorAssignments.primaryText;
                    newObj.color = colors[colorKey] || '#333333';
                    console.log(`🎨 [IMAGE-TEXT] ${newObj.elementType.toUpperCase()} gets primaryText color:`, colorKey, '→', newObj.color);
                } else if (newObj.elementType === 'p') {
                    // Paragraphen: Secondary Text Color
                    const colorKey = defaultColorAssignments.secondaryText;
                    newObj.color = colors[colorKey] || '#666666';
                    console.log(`🎨 [IMAGE-TEXT] P gets secondaryText color:`, colorKey, '→', newObj.color);
                } else {
                    // Meta-Text (kleine Labels): Grau für Hierarchie
                    newObj.color = '#888888';
                    console.log('🎨 [IMAGE-TEXT] Meta text gets gray color');
                }
                
                // ✅ Brand Fonts
                if (newObj.elementType === 'h1' && brandFonts.globalBigFont) {
                    newObj.fontFamily = brandFonts.globalBigFont;
                    console.log('🎨 [IMAGE-TEXT] H1 gets brand big font:', brandFonts.globalBigFont);
                } else if (brandFonts.globalSmallFont) {
                    newObj.fontFamily = brandFonts.globalSmallFont;
                    console.log('🎨 [IMAGE-TEXT] Text gets brand small font:', brandFonts.globalSmallFont);
                }
            }
            
            // ✅ PRICING TABLE TEXT COLORS & FONTS: Intelligente Farbwahl basierend auf Cell Background
            if (newObj.type === 'text' && 
                brandColors.length > 0 && 
                presetId === 'pricing-3' &&
                currentCellIndex !== null) {
                
                // ✅ ALLE CELLS: Heller Background → Dunkle Texte (clean & simple)
                if (newObj.elementType === 'h1') {
                    // Preis: Dunkelste Brand Color
                    newObj.color = darkestColor;
                    // ✅ NEW: Brand Big Font für H1
                    if (brandFonts.globalBigFont) {
                        newObj.fontFamily = brandFonts.globalBigFont;
                        console.log('🎨 Pricing H1 gets brand big font:', brandFonts.globalBigFont);
                    }
                } else if (newObj.elementType === 'h3') {
                    // Plan Name: Dunkler Text
                    newObj.color = '#1a1a1a';
                    // ✅ NEW: Brand Small Font für H3
                    if (brandFonts.globalSmallFont) {
                        newObj.fontFamily = brandFonts.globalSmallFont;
                        console.log('🎨 Pricing H3 gets brand small font:', brandFonts.globalSmallFont);
                    }
                } else {
                    // "per month" und Description: Grau
                    newObj.color = '#888888';
                    // ✅ NEW: Brand Small Font für P
                    if (brandFonts.globalSmallFont) {
                        newObj.fontFamily = brandFonts.globalSmallFont;
                        console.log('🎨 Pricing P gets brand small font:', brandFonts.globalSmallFont);
                    }
                }
                console.log('🎨 Pricing text color set (all light background)');
            }
            
            // ✅ PRICING TABLE BUTTONS: Intelligente Farbwahl + Brand Font
            if (newObj.type === 'button' && 
                brandColors.length > 0 && 
                presetId === 'pricing-3' &&
                currentCellIndex !== null) {
                
                // ✅ ALLE BUTTONS: Brand Color mit weißem Text (clean & simple)
                newObj.buttonColor = darkestColor;
                newObj.buttonTextColor = '#ffffff';
                console.log('🎨 Pricing button: brand color with white text (all same)');
                
                // ✅ NEW: Brand Small Font für Buttons
                if (brandFonts.globalSmallFont) {
                    newObj.buttonFontFamily = brandFonts.globalSmallFont;
                    console.log('🎨 Pricing button gets brand small font:', brandFonts.globalSmallFont);
                }
            }
            
            // ✅ GENERELLE TEXT COLOR ASSIGNMENTS (für alle anderen Presets)
            // Nur wenn NICHT bereits durch spezielle Preset-Logik gesetzt
            if (newObj.type === 'text' && 
                brandColors.length > 0 && 
                presetId !== 'premium-checklist' && 
                presetId !== 'premium-checklist-straight' && 
                presetId !== 'feature-list' &&
                presetId !== 'product-features-4' && 
                presetId !== 'pricing-3' && 
                presetId !== 'image-text-2col') { // image-text-2col hat eigene Logik oben
                
                // ✅ GLEICHE LOGIK wie in HeroHeader/DynamicContainerSection
                if (newObj.elementType === 'h1' || newObj.elementType === 'h2' || newObj.elementType === 'h3') {
                    // Überschriften: Primary Text Color
                    const colorKey = defaultColorAssignments.primaryText;
                    newObj.color = colors[colorKey] || '#333333';
                    console.log(`🎨 [GENERAL] ${newObj.elementType.toUpperCase()} gets primaryText color:`, colorKey, '→', newObj.color);
                } else {
                    // Paragraphen: Secondary Text Color
                    const colorKey = defaultColorAssignments.secondaryText;
                    newObj.color = colors[colorKey] || '#666666';
                    console.log(`🎨 [GENERAL] ${newObj.elementType} gets secondaryText color:`, colorKey, '→', newObj.color);
                }
            }
            
            // ✅ GENERELLE BUTTON COLOR ASSIGNMENTS (für alle anderen Presets)
            // Nur wenn NICHT bereits durch spezielle Preset-Logik gesetzt
            if (newObj.type === 'button' && 
                brandColors.length > 0 && 
                presetId !== 'pricing-3') {
                
                // ✅ GLEICHE LOGIK wie in HeroHeader/DynamicContainerSection
                const buttonColorKey = defaultColorAssignments.buttons;
                const buttonTextColorKey = defaultColorAssignments.buttonText;
                
                newObj.buttonColor = colors[buttonColorKey] || '#5C80BC';
                newObj.buttonTextColor = colors[buttonTextColorKey] || '#FFFFFF';
                
                console.log(`🎨 [GENERAL] Button gets buttonColor:`, buttonColorKey, '→', newObj.buttonColor);
                console.log(`🎨 [GENERAL] Button gets buttonTextColor:`, buttonTextColorKey, '→', newObj.buttonTextColor);
                
                // ✅ Brand Small Font für Buttons
                if (brandFonts.globalSmallFont) {
                    newObj.buttonFontFamily = brandFonts.globalSmallFont;
                    console.log('🎨 [GENERAL] Button gets brand small font:', brandFonts.globalSmallFont);
                }
            }
            
            // Recursively process children
            if (newObj.children) {
                newObj.children = addIdsRecursive(newObj.children, 0, currentCellIndex);
            }
            
            return newObj;
        }
        
        return obj;
    };
    
    const gridElement = {
        ...preset.grid,
        id: `grid-${timestamp}`,
        type: 'grid',
        order: order,
        visible: true,
        children: addIdsRecursive(preset.grid.children)
    };
    
    return gridElement;
};

